"use strict";

/**
* Adjusts the swatch color carousel to ensure the currently selected color is visible and centered when the slider is initialized.
*
* Attaches an "init" event handler to the ".swatch-slider" element, calculates the position of the selected color swatch,
* and programmatically navigates the Slick slider to bring the selected swatch into view. Handles edge cases where the
* selected swatch is near the beginning or end of the list, and accounts for the visibility of navigation buttons.
*
* @function
* @returns {void}
*/
const moveToActiveColor = () => {
    const VISIBLE_COLORS = 5;
    $(".swatch-slider").off("init").on("init", function (_event, slickSlider) {

        // Find the index of the currently selected slide
        const slickSlidesElements = $(this).find(".slick-slide");
        const elements = Array.from(slickSlidesElements);
        const index = elements.findIndex(element => element.querySelector(".selected") !== null);
        // Navigate the carousel to ensure the selected slide is visible
        if (index > VISIBLE_COLORS && index < elements.length - 7) {
            // If the selected slide is not near the start or end, center it
            slickSlider.slickGoTo(index - 3, true);
        } else if (index + 1 === elements.length) {
            // If the selected slide is the last one, show the last 7 slides
            slickSlider.slickGoTo(elements.length - 7, true);
        } else if (index > VISIBLE_COLORS) {
            // If the selected slide is past the visible threshold, show the last 7 slides
            slickSlider.slickGoTo(elements.length - 7, true);
        }

        const isPrevBtnVisible = $(".slick-prev").is(":visible");
        const isNextBtnVisible = $(".slick-next").is(":visible");
        const slickSlidesActiveElements = $(this).find(".slick-active");
        const activeElements = Array.from(slickSlidesActiveElements);
        const activeIndex = activeElements.findIndex(activeElement => activeElement.querySelector(".selected") !== null);

        if (index < VISIBLE_COLORS || (activeIndex !== 0 && activeIndex !== 6)) {
            return;
        }

        let goToPosition = elements.length - 7;

        if (activeIndex === 0 && isPrevBtnVisible) {
            goToPosition -= 1;
        }

        if (activeIndex === 6 && isNextBtnVisible) {
            goToPosition += 1;
        }

        slickSlider.slickGoTo(goToPosition, true);
    });
};

/**
* Initializes the color swatch carousel using the Slick slider plugin, customizes navigation controls,
* and implements custom navigation overlays to allow jumping multiple slides at a time.
*
* - Initializes the Slick carousel on elements with the `.swatch-slider` class.
* - Disables default Slick navigation buttons and adds custom overlay elements for navigation.
* - Overrides navigation button behavior to jump 5 slides forward or backward, addressing Slick slider limitations.
*
* @function
* @returns {void}
*/
const initColorsCarousel = () => {
    const $swatchSlider = $(".swatch-slider");
    const isQuickView = $(".mobile-quick-view-modal .product-quickview").length > 0;
    const numberOfColorsForInit = $swatchSlider.length && $swatchSlider.data("number-for-init");

    // do not init, if less than 6 color elements
    if (isQuickView && $swatchSlider.children().length <= numberOfColorsForInit) return;

    $swatchSlider.slick();

    // disable the nav buttons so we can hijack them later
    $swatchSlider.find(".slick-prev, .slick-next").attr("disabled", true);

    // create an overlay element to track clicks on
    const nextElement = $("<div class='slick-custom-nav slick-next-overlay'></div>");
    const prevElement = $("<div class='slick-custom-nav slick-prev-overlay'></div>");
    $(".slick-next").after(nextElement);
    $(".slick-prev").after(prevElement);

    // override the nav buttons with custom navigation to work around slick slider shortcomings
    $(".slick-custom-nav").off("click").on("click", function () {
        const slick = $swatchSlider.slick("getSlick");
        const totalSlides = slick.$slides.length;
        const currentSlide = slick.currentSlide;
        const isPrev = $(this).hasClass("slick-prev-overlay");

        const slideNumber = isPrev ? Math.max(currentSlide - 5, 0) : Math.min(currentSlide + 5, totalSlides - 7);

        $swatchSlider.slick("slickGoTo", slideNumber);
    });
};

module.exports = {
    moveToActiveColor: moveToActiveColor,
    initColorsCarousel: initColorsCarousel
};
